export default __webpack_public_path__ + "static/media/DOGE.7008ccc7.svg";